module.exports = __webpack_public_path__ + "static/img/partner-ref.ff762e8f.png";